{
  "back": "Kembali",
  "form": "Formulir",
  "purposeTitle": "Apa tujuan pemberhentian Anda?",
  "appointmentInfoTitle": "Informasi janji temu",
  "appointmentInfoHint": "Pastikan untuk mengisi kolom ini jika Anda memiliki janji temu.",
  "checkInDetailsTitle": "Detail Check-in",
  "checkInDetailsHint": "Informasi tambahan tentang kunjungan Anda.",
  "driverPhoneLabel": "Nomor Telepon Pengemudi",
  "activateWhatsAppTitle": "Aktifkan Pesan WhatsApp",
  "activateWhatsAppBody": "Untuk mengobrol dengan gudang, balas \"OK\" saat kami mengirimkan pesan WhatsApp pertama kepada Anda.",
  "whatsappDelayBanner": "Pesan WhatsApp pertama mungkin memerlukan waktu hingga satu menit untuk tiba.",
  "notesLabel": "Catatan",
  "notesPlaceholder": "Ada instruksi khusus atau catatan untuk fasilitas?",
  "verifyAndCheckIn": "Verifikasi dan check-in",
  "completeCheckIn": "Selesaikan check-in",
  "visitGroupInbound": "Masuk",
  "visitGroupOutbound": "Keluar",
  "visitGroupBoth": "Masuk & Keluar",
  "visitUnloadTruck": "Bongkar muatan truk saya",
  "visitDropTrailer": "Lepas trailer atau kontainer saya",
  "visitLoadTruck": "Muat truk saya",
  "visitHookTrailer": "Sambungkan trailer atau kontainer",
  "visitUnloadLoad": "Bongkar & Muat truk saya",
  "visitDropHook": "Lepas & Sambungkan trailer atau kontainer",
  "containerTrailer": "Trailer",
  "containerContainer": "Kontainer",
  "containerOversized": "Berukuran besar",
  "containerOther": "Lainnya",
  "defaultReferenceName": "Nomor PO",
  "identifierSuffix": "{reference} atau Nomor Konfirmasi",
  "licenseOrDotRequired": "Harap isi Pelat Nomor atau Nomor DOT",
  "appointmentNotFound": "Kami tidak dapat menemukan janji temu Anda",
  "referenceNotFound": "Tidak ditemukan janji temu yang cocok. Nomor referensi peka huruf besar/kecil.",
  "referenceCaseSensitiveHint": "Nomor referensi peka huruf besar/kecil",
  "messaging": {
    "whatsappFailedTitle": "Tidak dapat mengirim pesan WhatsApp",
    "smsFailedTitle": "Tidak dapat mengirim pesan SMS",
    "whatsappFailedBody": "Kami tidak dapat mengirim pesan ke {displayPhone}. <br /><br /> Jika sebelumnya Anda telah berhenti berlangganan, kirim pesan START ke <a href='{waUrl}' target='_blank' rel=\"noopener noreferrer\">{senderPhone}</a> untuk mulai menerima pesan dari gudang ini.",
    "smsFailedBody": "Kami tidak dapat mengirim pesan ke {displayPhone}. <br /><br /> Jika sebelumnya Anda telah berhenti berlangganan, kirim pesan START ke <a href='{smsUrl}'>{senderPhone}</a> untuk mulai menerima pesan SMS dari gudang ini.",
    "fallbackPhone": "nomor telepon yang diberikan"
  }
}
